import TextButton from '@shared/components/core/button/TextButton';
import ContentDialog from '@shared/components/core/dialog/ContentDialog';
import { BodyMedium } from '@shared/components/core/text/Typography';
import OrganizationContainer from '@shared/hooks/state/OrganizationContainer';
import OrganizationMemberInviteModel from '@shared/models/organizations/OrganizationMemberInviteModel';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import InviteDetailStack from './InviteDetailStack';

interface IInviteDeleteAccessProps {
    invite: OrganizationMemberInviteModel;
}

export default function InviteDeleteAccess({ invite }: IInviteDeleteAccessProps) {
    const { t } = useTranslation();
    const organizationContainer = OrganizationContainer.useContainer();
    const [showRemoveDialog, setShowRemoveDialog] = useState<boolean>(false);
    const handleRemove = () => {
        setShowRemoveDialog(true);
    };

    const handleCancelRemove = () => {
        setShowRemoveDialog(false);
    };

    const handleConfirmDeleteInvite = async () => {
        if (invite.organizationId) {
            await organizationContainer.deleteOrganizationInvite(invite.organizationId, invite.id);
        }
        setShowRemoveDialog(false);
    };

    if (!invite) return null;
    return (
        <>
            <TextButton variant="negative" startIcon="delete" onClick={handleRemove}>
                {t('common:delete')}
            </TextButton>
            <ContentDialog
                open={showRemoveDialog}
                onConfirm={handleConfirmDeleteInvite}
                onCancel={handleCancelRemove}
                onClose={handleCancelRemove}
                title={t('common:organization.invite.confirm')}
                confirmButtonText={t('common:organization.invite.delete')}>
                <>
                    <InviteDetailStack invite={invite} />
                    <BodyMedium>{t('common:organization.invite.confirmLong')}</BodyMedium>
                </>
            </ContentDialog>
        </>
    );
}
